const { default: activities } = require("./activities");

const fakeData = [...activities];

export default fakeData;